import React from 'react';
import {
  Route,
  Redirect,
  Switch,
} from 'react-router-dom';
import { connect } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';
import { asyncComponent } from '../utils/asyncComponent';
import MainLayout from '../views/MainLayout/MainLayout';

import { selectRoute } from './routeUtils';

import { history } from '../store/createStore';

const NoMatch = asyncComponent(() => import('../views/NoMatch/NoMatch'));

const mapStateToProps = (state) => ({
  menuData: state.root.menuData,
});

const routes = (props) => {
  const routeData = selectRoute(props.menuData);

  return (
    <ConnectedRouter history={history} key={Math.random()}>
      <Switch>
        <MainLayout history={history} >
          <Switch>
            <Redirect exact from="/" to="/home" />
            {Object.keys(routeData).map((key) => {
              return (
                <Route exact path={key} component={routeData[key].component} />
              );
            })}
            <Route component={NoMatch} />
          </Switch>
        </MainLayout>
      </Switch>
    </ConnectedRouter>
  );
};

export default connect(mapStateToProps)(routes);



// WEBPACK FOOTER //
// ./src/routes/mainRoute.js